// @flow
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const CommentDetail = styled.div`
  margin-bottom: 12px;
  ${getFont(-1, 'compact')};

  &:last-child {
    margin-bottom: 6px;
  }

  ${minMediaQueries.phablet`
    display: flex;
    align-items: flex-start;
  `};

  > *:nth-child(2) {
    position: relative;
    flex: 1;
    padding-left: 18px;

    ${maxMediaQueries.phablet`
      margin-left: 3px;
      padding-left: 15px;
    `};

    &:before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      border: 1.5px solid ${({ theme, isAuthor }) => (isAuthor ? theme.secondaryColor : theme.borderColor)};
      border-radius: 1.5px;
      content: '';
      background-color: ${({ theme, isAuthor }) => (isAuthor ? theme.secondaryColor : theme.borderColor)};
    }
  }
`;

export const CommentAuthor = styled.div`
  width: 114px;
  min-width: 114px;
  max-width: 114px;
  word-break: break-word;

  a {
    color: currentColor;

    &:hover {
      color: ${({ theme }) => theme.mainColor};
    }
  }

  ${maxMediaQueries.phablet`
    padding-bottom: 6px;
  `};

  ${minMediaQueries.phablet`
    padding-right: 18px;
    text-align: right;

    div {
      text-align: left;
    }
  `};
`;

export const CommentText = styled.div`
  min-width: 1%;
  word-break: break-word;
`;
